"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfferTypeTagIcon = getOfferTypeTagIcon;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
function getOfferTypeTagIcon(offerTypeId) {
    switch (offerTypeId) {
        case types_1.EOfferType.internship:
            return (0, jsx_runtime_1.jsx)(elements_1.Icon, { type: "man-graduate" });
        case types_1.EOfferType.permanent:
            return (0, jsx_runtime_1.jsx)(elements_1.Icon, { type: "business-deal-handshake" });
        case types_1.EOfferType.temporary_job:
            return (0, jsx_runtime_1.jsx)(elements_1.Icon, { type: "profession-man-constructor" });
        case types_1.EOfferType.volunteering:
            return (0, jsx_runtime_1.jsx)(elements_1.Icon, { type: "heart-hands-handshake" });
        case types_1.EOfferType.work_and_travel:
            return (0, jsx_runtime_1.jsx)(elements_1.Icon, { type: "sailing-person" });
        case types_1.EOfferType.contractor:
            return (0, jsx_runtime_1.jsx)(elements_1.Icon, { type: "briefcase-contractor" });
        default:
            break;
    }
}
